import { RedirectToMissionsPage } from '#src/components/missions/RedirectToMissionsPage/index.tsx';

const MissionsPage = () => {
  return <RedirectToMissionsPage />;
};

export default MissionsPage;
